import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router, UrlSerializer} from '@angular/router';
import {Subject} from 'rxjs';
import {SessionService} from '../Session/session-service.service';
import {environment} from '../../../environments/environment';
import {MessageService} from 'primeng/api';
import {catchError, timeout} from 'rxjs/operators';
import {any} from 'codelyzer/util/function';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  http: HttpClient;
  serializer: UrlSerializer;
  router: Router;
  env = environment;
  urlApiMongo: 'https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementarydb-suzrx/graphql';
  urlApiJwt: 'https://us-east-1.aws.realm.mongodb.com/api/client/v2.0/app/elementarydb-suzrx/auth/providers/api-key/login';
  keyJwt: 'IP0isJaBqOedEdCCIrDcTzgyC4AZ5nn2lqanxFYRsvV57HXQYQTiBdZd5JD02GRy';
  private _responseApiLogin = new Subject();
  responseApiLogin$ = this._responseApiLogin.asObservable();
  private _responseApiOtp = new Subject();
  responseApiOtp$ = this._responseApiOtp.asObservable();
  private _responseApiRegister = new Subject();
  responseApiRegister$ = this._responseApiRegister.asObservable();
  private _responseApiForgotId = new Subject();
  responseApiForgotId$ = this._responseApiForgotId.asObservable();
  private _responseApiCannotLogin = new Subject();
  responseApiCannotLogin$ = this._responseApiCannotLogin.asObservable();
  private _responseApiLoadImage = new Subject();
  responseApiLoadImage$ = this._responseApiLoadImage.asObservable();
  private _responseApiRenovation = new Subject();
  responseApiRenovation$ = this._responseApiRenovation.asObservable();
  private _responseApiGetProfileImage = new Subject();
  responseApiGetProfileImage$ = this._responseApiGetProfileImage.asObservable();
  private _responseApiCoupons = new Subject();
  responseApiCoupons$ = this._responseApiCoupons.asObservable();
  private _responseGet = new Subject();
  responseGet$ = this._responseGet.asObservable();
  private _responseGetBenefit = new Subject();
  responseGetBenefit$ = this._responseGetBenefit.asObservable();
  private _responseGetProfile = new Subject();
  responseGetProfile$ = this._responseGetProfile.asObservable();
  private _responseDigitalCard = new Subject();
  responseDigitalCard$ = this._responseDigitalCard.asObservable();
  private _responseSessions = new Subject();
  responseSessions$ = this._responseSessions.asObservable();
  private _responseCouponRenovation = new Subject();
  responseCouponRenovation$ = this._responseCouponRenovation.asObservable();
  private _responseAuthorization = new Subject();
  responseAuthorization$ = this._responseAuthorization.asObservable();
  private _responseClaim = new Subject();
  responseClaim$ = this._responseClaim.asObservable();
  constructor(private htt: HttpClient, private rout: Router, private serial: UrlSerializer, private session: SessionService, private ms: MessageService) {
    this.http = htt;
    this.router = rout;
    this.serializer = serial;
  }
  getMethodGeneral(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + '/' + path;
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseGet.next(datas);
      //console.log('response:  ', q);
      //console.log('response:  ', data);
      const ws = JSON.parse(JSON.stringify(datas)).code;
      if (ws !== 701 || ws !== 711) {
        this.ms.add({severity: 'error', summary: 'error', detail: datas.code, sticky: false});
      }
    });
  }
  getMethodBenefit(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + '/' + path;
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseGetBenefit.next(datas);
      //console.log('response:  ', q);
      //console.log('response:  ', data);
      const ws = JSON.parse(JSON.stringify(datas)).code;
      if (ws !== 701 || ws !== 711) {
        this.ms.add({severity: 'error', summary: 'error', detail: datas.code, sticky: false});
      }
    });
  }
  getMethodProfile(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + '/' + path;
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseGetProfile.next(datas);
      //console.log('response:  ', q);
      //console.log('response:  ', data);
      const ws = JSON.parse(JSON.stringify(datas)).code;
      if (ws !== 701 || ws !== 711) {
        this.ms.add({severity: 'error', summary: 'error', detail: datas.code, sticky: false});
      }
    });
  }
  getAuthorization(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseAuthorization.next(datas);
      // console.log('response:  ', datas);
      const ws = JSON.parse(JSON.stringify(datas)).code;
      if (ws !== 701 || ws !== 711) {
        this.ms.add({severity: 'error', summary: 'error', detail: datas.code, sticky: false});
      }
    });
  }

  getClaim(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseClaim.next(datas);
      // console.log('response:  ', datas);
      const ws = JSON.parse(JSON.stringify(datas)).code;
      if (ws !== 701 || ws !== 711) {
        this.ms.add({severity: 'error', summary: 'error', detail: datas.code, sticky: false});
      }
    });
  }
  postDigitalCard(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
  }
  getMethod(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    let d = any;
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header})
    .pipe(
      timeout(20000),
      catchError(e => {
        // do something on a timeout
        this.ms.add({severity: 'error', summary: '504',
          detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
        return e;
      })
    )
    .subscribe(datas => {
      const s = JSON.parse(JSON.stringify(datas));
      if (s.code == 700 || s.code == 701 || s.code == 711 || s.operationStatus == 1 || s.operationStatus == 0) {
        // this._responseApiLogin.next(datas);
        d = s;
      } else {
        this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Por favor verifique que haya ingresado bien sus datos.', sticky: false});
        // this._responseApiLogin.next(datas);
      }
      this._responseApiLogin.next(datas);
      console.log('response ws:  ', datas);
});
  }
  getCouponRenovationMethod(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    console.log('params from db:  ', q);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe(datas => {
      this._responseCouponRenovation.next(datas);
    });
  }
  async getMethodSession(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    await this.http.get( url + '/' + path, {params: data, headers: header}).subscribe(datas => {
      return this._responseSessions.next(datas);
    });
  }
  getMethodRenovation(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseApiRenovation.next(datas);
      this.env.renovation = datas;
      console.log('params from db:  ', datas);
    });
  }
  getMethodImageProfile(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseApiGetProfileImage.next(datas);
      console.log('params from db:  ', datas);
    });
  }
  getInsuredCoupons(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header}).subscribe((datas: any) => {
      this._responseApiCoupons.next(datas);
    });
  }
  getMethodOtp(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.get( url + '/' + path, {params: data, headers: header})
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe(datas => {
      const s = JSON.parse(JSON.stringify(datas));
      if (s.code == 700 || s.code == 701 || s.code == 711 ) {
        this._responseApiOtp.next(datas);
      } else {
        this.ms.add({severity: 'error', summary: 'Error',
          detail: 'El codigo proporcionado es incorrecto', sticky: false});
        this._responseApiOtp.next(datas);
      }
      // this._responseApiOtp.next(datas);
      console.log('response ws:  ', datas);
    });
  }
  /*
  postMethod(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    header.set('Content-Type', 'application/json');
    this.http.post( url + '/' + path, {body: params, headers: header}).subscribe(datas => {
      this._responseApiRegister.next(datas);
    });
  }*/

  postMethod(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    // const w = this.router.createUrlTree([], {queryParams: params});
    // const q = url + this.serializer.serialize(w);
    // header.set('Content-Type', 'application/json');
    // header.set('Accept', 'application/json');
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.post( url + '/' + path, data)
        .pipe(
            timeout(25000),
            catchError(e => {
              // do something on a timeout
              /*
              this.ms.add({severity:'error', summary:"504",
                detail:'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return of({code:504,error:{status:504}});*/
              return e;
            })
        ).subscribe((datas: any) => {
      console.log('response ws:  ', datas.resultCode);
      if (datas.resultCode == 700) {
        // this.responsePost.next(datas.response);
      } else {
        if (datas.code == 614) {
        this.ms.add({severity: 'error', summary: '614',
          detail: 'Ha ocurrido un error interno en la creación', sticky: false});
        }
      }
    });
  }

  postMethodRegister(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.post( url + '/' + path, data)
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe((datas: any) => {
      // console.log("response ws:  ",datas.resultCode);
      console.log('response ws:  ', datas);
      if (datas.code == 701) {
        this._responseApiRegister.next(datas);
      } else {
        if (datas.code == 610) {
          console.log('usuario ya existe');
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Usuario ya existe', sticky: false});
          this._responseApiRegister.next(datas);
        }

      }
    });
  }

  postMethodForgotId(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.post( url + '/' + path, data)
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe((datas: any) => {
      // console.log("response ws:  ",datas.resultCode);
      console.log('response ws:  ', datas);
      if (datas.code == 701) {
        this._responseApiForgotId.next(datas);
      } else {
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Existió un error en la petición, por favor intente más tarde.', sticky: false});
          this._responseApiForgotId.next(datas);
      }
    });
  }

  postMethodCannotLogin(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.post( url + '/' + path, data)
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe((datas: any) => {
      // console.log("response ws:  ",datas.resultCode);
      console.log('response ws:  ', datas);
      if (datas.code == 701) {
        this._responseApiCannotLogin.next(datas);
      } else {
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Existió un error en la petición, por favor intente más tarde.', sticky: false});
          this._responseApiCannotLogin.next(datas);
      }
    });
  }

  postMethodLoadImageProfile(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.post( url + '/' + path, data)
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe((datas: any) => {
      // console.log("response ws:  ",datas.resultCode);
      console.log('response ws:  ', datas);
      if (datas.status == 200) {
        this._responseApiLoadImage.next(datas);
      } else {
        if (datas.code == 610) {
          console.log('usuario ya existe');
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Usuario ya existe', sticky: false});
          this._responseApiLoadImage.next(datas);
        } else {
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Existió un error en la carga, por favor intentar más tarde.', sticky: false});
          this._responseApiLoadImage.next(datas);
        }
      }
    });
  }

  async putMethodInsuredRegister(url: string, path: string,  headers: any[], data: any ) {
    const params = new HttpParams();
    const header = new HttpHeaders();

    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    console.log('response ws:  ', url + '/' + path);
    console.log('response ws:  ', data);
    this.http.put( url + '/' + path, data)
        .pipe(
            timeout(10000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity: 'error', summary: '504',
                detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        ).subscribe((datas: any) => {
      // console.log("response ws:  ",datas.resultCode);
      console.log('response ws:  ', datas);
      if (datas.code == 701) {
        
        //return 
      } else {
        if (datas.code == 610) {
          console.log('usuario ya existe');
          this.ms.add({severity: 'error', summary: 'Error',
          detail: 'Usuario ya existe', sticky: false});
          //return this._responseApiRegister.next(datas);
        }
      }
      return this._responseApiRegister.next(datas);
    });
  }

  putMethod(url: string, path: string,  headers: any[], data: HttpParams ) {
    const params = new HttpParams();
    const header = new HttpHeaders();
    headers.forEach(val => {
      header.set(val.key, val.value);
    });
    const w = this.router.createUrlTree([], {queryParams: params});
    const q = url + this.serializer.serialize(w);
    this.http.put( url + '/' + path, {body: params, headers: header}).subscribe(datas => {
      this._responseApiRegister.next(datas);
    });
  }

  /*
  postMethodJWT(url: string,  headers: any[], data: any ) {
    console.log("url mongo:  ",url);
    console.log("data mongo:  ",data);
    let promise = new Promise((resolve, reject) => {
      this.http.post( url, {key: data} )
        .pipe(
            timeout(25000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity:'error', summary:"504",
                detail:'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
              return e;
            })
        )
        .toPromise()
        .then(res => {
          console.log("res: ", res);
          resolve(res);
        })
    });
    return promise;
  }

  postMethodMongo(url: string,  jwt: string, data: any ) {
    let header = new HttpHeaders({
      Authorization: 'Bearer '+jwt });
    let options = { headers: header };
    console.log("header ",options)
    console.log("url mongo:  ",url);
    console.log("data mongo:  ",data);
    let promise = new Promise((resolve, reject) => {
      this.http.post( url, {query: data}, { headers: header } )
        .pipe(
            timeout(15000),
            catchError(e => {
              // do something on a timeout
              this.ms.add({severity:'error', summary:"504",
                detail:'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina', sticky: false});
                reject({code:504,error:{status:504}});
              return e;
            })
        ).toPromise()
        .then(res => {
          console.log("res: ", res);
          resolve(res);
        })
    });
    return promise;
  }*/

  postMethodJWTTS() {
    console.log('url urlApiJwt:  ', this.env.urlApiJwtTS);
    const header = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    });

    const bodyEncoded:any = {
      grant_type: this.env.GRANT_TYPE,
      client_id: this.env.CLIENT_ID,
      client_secret: this.env.CLIENT_SECRET,
      scope: this.env.SCOPE
    }

    let formBody:any = [];
    for (var property in bodyEncoded) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(bodyEncoded[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiJwtTS, formBody, {headers: header})
          .pipe(
              timeout(2000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res urlApiJwt: ', res);
        resolve(res.access_token);
      });
    });
  }

  async postMethodTS(query: any ) {
    const jwtv = await this.postMethodJWTTS();
    const header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Llave-Ts': this.env.LLAVE_TS,
      'Authorization': 'Bearer ' + jwtv,
      'Access-Control-Allow-Origin': '*'
    });
    const options = {headers: header};
    //console.log('header ', options);
    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiCardTs, query, {headers: header})
          .pipe(
              timeout(90000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                reject({code: 504, error: {status: 504}});
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res mongoquery: ', res);
        if ( !res.error ) {
          resolve(res.objRespuesta);
        }
        resolve(res);
      });
    });
        /**/
  }


  postMethodJWT() {
    console.log('url urlApiJwt:  ', this.env.urlApiJwt);
    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiJwt, {key: this.env.keyJwt})
          .pipe(
              timeout(2000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res urlApiJwt: ', res);
        resolve(res.access_token);
      });
    });
  }
  async postMethodMongo(query: any ) {
    //console.log('url mongo:  ', this.env.urlApiMongo);
    //console.log('url JWT:  ', this.env.urlApiJwt);
    //console.log('data mongo:  ', query);
    const jwtv = await this.postMethodJWT();
    /*return new Promise((resolve, reject) => {

    });*/
    const header = new HttpHeaders({
      Authorization: 'Bearer ' + jwtv
    });
    const options = {headers: header};
    //console.log('header ', options);
    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiMongo, query, {headers: header})
          .pipe(
              timeout(90000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                reject({code: 504, error: {status: 504}});
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res mongoquery: ', res);
        resolve(res);
      });
    });
        /**/
  }

  postMethodJWTSettings() {
    console.log('url urlApiJwtSettings:  ', this.env.urlApiJwtSettings);
    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiJwtSettings, {key: this.env.keyJwtSettings})
          .pipe(
              timeout(2000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res urlApiJwt: ', res);
        resolve(res.access_token);
      });
    });
  }

  async postMethodMongoSettings(query: any ) {
    const jwtv = await this.postMethodJWTSettings();
    const header = new HttpHeaders({
      Authorization: 'Bearer ' + jwtv
    });
    const options = {headers: header};
    return new Promise((resolve, reject) => {
      this.http.post(this.env.urlApiMongoSettings, query, {headers: header})
          .pipe(
              timeout(90000),
              catchError(e => {
                // do something on a timeout
                this.ms.add({
                  severity: 'error',
                  summary: '504',
                  detail: 'Upps.. tal parece que se esta tardando mas de lo usual, revisa tu conexion a internet o trata de recargar la pagina',
                  sticky: false
                });
                reject({code: 504, error: {status: 504}});
                return e;
              })
          ).subscribe((res: any) => {
        //console.log('res mongoquery: ', res);
        resolve(res);
      });
    });
        /**/
  }
}